import { Text } from '@wix/design-system';
import classNames from 'classnames';
import * as React from 'react';
import { EllipsisContext } from './EllipsisContext';
import s from './EllipsisText.scss';
export const EllipsisText = ({ text, maxWidth, componentProps = {}, as: Component = Text, delimiterPosition = 'middle', }) => {
    const delimiter = '...';
    const rootSpanRef = React.useRef(null);
    const testNodeSpanRef = React.useRef(null);
    const [isInitialized, setIsInitialized] = React.useState(false);
    const { displayTruncatedText, setDisplayTruncatedText } = React.useContext(EllipsisContext);
    React.useEffect(() => {
        setIsInitialized(true);
        setDisplayTruncatedText(calculateTruncatedText(text, delimiter, rootSpanRef, testNodeSpanRef, maxWidth, delimiterPosition));
    }, []);
    React.useEffect(() => {
        setDisplayTruncatedText(calculateTruncatedText(text, delimiter, rootSpanRef, testNodeSpanRef, maxWidth, delimiterPosition));
    }, [maxWidth, text, delimiterPosition]);
    const rootClassName = classNames(s.root, {
        [s.initialized]: isInitialized,
        [s.fullWidth]: !isInitialized,
    });
    return (React.createElement("span", { className: rootClassName, ref: rootSpanRef },
        React.createElement(Component, { ...componentProps, dataHook: "ellipsis-text" }, displayTruncatedText),
        React.createElement("span", { className: s.testNodeWrapper },
            React.createElement(Component, { ...componentProps },
                React.createElement("span", { ref: testNodeSpanRef, className: s.testText })))));
};
const measureTextWidth = (testNodeSpanRef, content) => {
    if (testNodeSpanRef.current) {
        testNodeSpanRef.current.innerHTML = content;
        return testNodeSpanRef.current.getBoundingClientRect().width;
    }
    return 0;
};
const fitTextWithinWidth = (testNodeSpanRef, textPart, maxWidth, reverse = false) => {
    let displayText = textPart;
    while (measureTextWidth(testNodeSpanRef, displayText) > maxWidth) {
        displayText = reverse ? displayText.slice(1) : displayText.slice(0, -1);
    }
    return displayText;
};
const getMaxWidth = (rootSpanRef, maxWidth) => {
    if (maxWidth) {
        return maxWidth;
    }
    if (rootSpanRef.current) {
        return rootSpanRef.current.getBoundingClientRect().width;
    }
    return 0;
};
const calculateTruncatedText = (text, delimiter, rootSpanRef, testNodeSpanRef, maxWidth, delimiterPosition = 'middle') => {
    const fullTextWidth = measureTextWidth(testNodeSpanRef, text);
    const availableWidth = getMaxWidth(rootSpanRef, maxWidth);
    if (fullTextWidth <= availableWidth) {
        return text;
    }
    const delimiterWidth = measureTextWidth(testNodeSpanRef, delimiter);
    const availableTextWidth = availableWidth - delimiterWidth;
    if (delimiterPosition === 'start') {
        const truncatedPart = fitTextWithinWidth(testNodeSpanRef, text, availableTextWidth, true);
        return `${delimiter}${truncatedPart}`;
    }
    if (delimiterPosition === 'end') {
        const truncatedPart = fitTextWithinWidth(testNodeSpanRef, text, availableTextWidth);
        return `${truncatedPart}${delimiter}`;
    }
    const halfWidth = availableTextWidth / 2;
    const leftPart = fitTextWithinWidth(testNodeSpanRef, text.slice(0, text.length / 2), halfWidth);
    const rightPart = fitTextWithinWidth(testNodeSpanRef, text.slice(text.length / 2), halfWidth, true);
    return `${leftPart}${delimiter}${rightPart}`;
};
//# sourceMappingURL=EllipsisText.js.map